import { Box, Typography } from '@mui/material';
import { CheckCircleOutlined } from '@mui/icons-material';

const calculateAge = (dob) => {
  const [yyyy, mm, dd] = dob.split('-');
  const birth = new Date(`${yyyy}-${mm}-${dd}`);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
};

const FieldDisplay = ({ label, value }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1, minWidth: 0 }}>
    <Typography variant='labelS' sx={{ color: '#666', fontWeight: 700 }}>
      {label}
    </Typography>
    <Typography variant='body1' sx={{ color: '#333' }}>
      {value}
    </Typography>
  </Box>
);

const DigiLockerResultCard = ({ data }) => {
  const age = data?.date_of_birth ? calculateAge(data.date_of_birth) : '';
  const gender = data?.gender
    ? data.gender.charAt(0) + data.gender.slice(1).toLowerCase()
    : '-';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <CheckCircleOutlined sx={{ color: 'green', fontSize: 24 }} />
        <Typography variant='body1' sx={{ color: '#000' }}>
          Digi-Locker Captured
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <FieldDisplay label='Name' value={data?.name || '-'} />
        <FieldDisplay label='Gender' value={gender} />
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <FieldDisplay label='Date of Birth' value={data?.date_of_birth || '-'} />
        <FieldDisplay label='Age' value={age ? `${age}y` : '-'} />
      </Box>
    </Box>
  );
};

export default DigiLockerResultCard;
